import React from "react";
import { Checkbox } from "../ui/Checkbox";
import { CheckableLayer, Filter } from "../../types/Layer";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/Accordion";
import { FilterSymbol } from "./FilterSymbol";
import { TruncatedTooltipText } from "../map/TruncatedTooltipText";

interface SubFilterItemsProps {
    subFilters: CheckableLayer[];
    toggleSubFilter: (layerId: string) => void;
    layerId: string;
}

export const SubFilterItems: React.FC<SubFilterItemsProps> = ({
    subFilters,
    toggleSubFilter,
    layerId,
}) => {
    return (
        <div className="flex flex-col">
            {subFilters.map((filter) => (
                <div key={filter.id}>
                    {filter.subFilters ? (
                        <Accordion type="multiple" className="px-0">
                            <AccordionItem value={filter.label}>
                                <AccordionTrigger
                                    className="px-2 py-1 m-0 pl-6 hover:bg-[#F9F9F9] dark:hover:bg-gray-700 rounded-[4px] duration-300"
                                    checkboxProps={{
                                        checked: filter.visible,
                                        onCheckedChange: () =>
                                            toggleSubFilter(filter.id),
                                        disabled: false,
                                    }}
                                >
                                    <TruncatedTooltipText
                                        text={filter.label}
                                        className="text-[13px] text-[#535353] dark:text-[#CEE0EF] select-none items-center gap-2 max-w-[95px]"
                                    />
                                </AccordionTrigger>
                                <AccordionContent>
                                    <SubFilterItems
                                        subFilters={filter.subFilters}
                                        toggleSubFilter={toggleSubFilter}
                                        layerId={filter.id}
                                    />
                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>
                    ) : (
                        <div className="flex items-center gap-2 py-1 px-2 pl-12">
                            <Checkbox
                                id={`${layerId}-${filter.id}`}
                                checked={filter.visible}
                                onCheckedChange={() =>
                                    toggleSubFilter(filter.id)
                                }
                                className="rounded-[3px] border-[#C6C5C5] data-[state.visible]:bg-accent1 data-[state.visible]:border-accent1"
                            />
                            <FilterSymbol
                                symbolType={(filter as Filter).symbolType}
                                color={(filter as Filter).color}
                                icon={(filter as Filter).icon}
                            />
                            <TruncatedTooltipText
                                text={filter.label}
                                className="text-[13px] text-[#535353] dark:text-[#CEE0EF] cursor-pointer select-none items-center gap-2 max-w-[95px]"
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
